import dayjs from "dayjs";
import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import { toFixed2, toNumber } from "../components/exportUtils";

const due = (row) => toNumber(row?.total) - toNumber(row?.paid_amount);
const lastOrder = (row) => (row?.last_order ? dayjs(row.last_order).format("DD/MM/YYYY") : "-");

const columns = [
    { key: "customer_id", label: "Customer Id" },
    { key: "name", label: "Customer Name", primary: true },
    { key: "orders", label: "Orders", align: "right" },
    { key: "total", label: "Total Spent", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total)), exportValue: (row) => toFixed2(row?.total) },
    { key: "paid_amount", label: "Paid", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.paid_amount)), exportValue: (row) => toFixed2(row?.paid_amount) },
    { key: "due", label: "Due", align: "right", render: (row) => CurrencyFormatter(due(row)), exportValue: (row) => due(row).toFixed(2) },
    { key: "last_order", label: "Last Order", render: lastOrder, exportValue: lastOrder },
];

const ShopCustomerOrdersReport = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Shop Orders By Customer", websiteData);

    const report = useServerReport("report/shop-customer-orders");

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Shop Orders By Customer" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Shop Orders By Customer" filename="shop-orders-by-customer" searchPlaceholder="Search by customer id or name" />
            <ReportTable report={report} columns={columns} />
        </div>
    </div>);
};

export default withAdminAuth(ShopCustomerOrdersReport);
